"use client";

import mixpanel from "mixpanel-browser";

let initialized = false;

export function initMixpanel() {
  if (!initialized && typeof window !== "undefined") {
    mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN!, {
      debug: process.env.NODE_ENV === "development",
      persistence: "localStorage",
      track_pageview: false,
      cross_subdomain_cookie: true,
      api_host: process.env.NEXT_PUBLIC_MIXPANEL_HOST!
    });

    initialized = true;
  }
}

export default mixpanel;

